import axios from 'axios';

const get = (context, path, params) =>
	axios
		.get(`${context.rootGetters['settings/getUrl']}orderboard${path}`, {
			params,
			headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
		})
		.then(res => res.data.data);

const actions = {
	// Board ordini: status in lavorazione, passaggi, numeri grandi e flusso entrati/usciti
	fetchSummary: context => get(context, ''),
	// { [orderId]: { level, statusName, ageMs, limitMs } } per i badge di lista e scheda ordine
	fetchLate: context => get(context, '/late'),
};

export default {
	namespaced: true,
	state: {},
	mutations: {},
	getters: {},
	actions,
};
